import { sbaAxios } from "../utils/sbaAxios";
import { getPortfolios } from "../../config/apiConfig";
import {
  FETCH_PORTFOLIO_FAILURE,
  FETCH_PORTFOLIO_SUCCESS,
  FETCH_PORTFOLIO_BEGIN
  } from '../constants/portfolio';


export const getPortfolioListAction=()=> {
  return (dispatch) => {
      dispatch(fetchPortfolioListBegin());
      sbaAxios({
          url: `${getPortfolios}`,
          method: 'get',
      })
      .then((repos) => {
        const PortfolioList = repos;
        dispatch(fetchPortfolioListSuccess(PortfolioList.sort((a, b) => a.Name.localeCompare(b.Name))));
        return PortfolioList;
      })
      .catch((error) => dispatch(fetchPortfolioListFailure(error)));
  };
}

export const fetchPortfolioListBegin = () => ({
  type: FETCH_PORTFOLIO_BEGIN,
});

export const fetchPortfolioListSuccess = (portfolioDataItem) => ({
  type: FETCH_PORTFOLIO_SUCCESS,
  payload: {portfolioDataItem},
});


export const fetchPortfolioListFailure = (errorMessage) => ({
  type: FETCH_PORTFOLIO_FAILURE,
  payload: {errorMessage}
});

